
document.addEventListener("DOMContentLoaded", () => {

  if (!document.querySelector('.devis-page')) return;

  const queryString = window.location.search;
	let urlProducts = [];
	let urlParams = undefined;
	let urlGammes = [];
	let settedGamme = false;
	let settedProduct = false;
  

  const form = document.getElementById("devis");
  const buttons = form.querySelectorAll('button');
  const submitButton = form.querySelector('input[type="submit"]')
  const carousel = document.getElementById("form-carousel");
  const arrows = document.querySelectorAll(".arrow-next");
  const steps = document.querySelector("#devis > div.steps");
  const loadingContainer = document.getElementById("loading-container");

  const gammeInputContainer = document.querySelector("#gamme-input-container");
  const gammeInputs = document.querySelectorAll(".gamme-input");

  const productInputWrapper = document.querySelectorAll('.product-input-wrapper');
  const productInputs = document.querySelectorAll('.product-input');

  const tag = document.querySelector('#tag-input');

  let currentStep = 1;
  let isPhoneWanted = false;

  const errorMessages = {
    en: {
        lastname: "Last name is required",
        firstname: "First name is required",
        emailInvalid: "Invalid email",
        emailRequired: "Email is required",
        phone: "Phone is required",
        country: "Country is required",
        postal: "Postal code is required",
        gammes: "You must select at least one choice",
        products: "You must select at least one choice",
        gdpr: "This field is required"
    },
    fr: {
        lastname: "Le nom est requis",
        firstname: "Le prénom est requis",
        emailInvalid: "Email invalide",
        emailRequired: "L'email est requis",
        phone: "Le téléphone est requis",
        country: "Le pays est requis",
        postal: "Le code postal est requis",
        gammes: "Vous devez sélectionner au moins un choix",
        products: "Vous devez sélectionner au moins un choix",
        gdpr: "Ce champ est requis"
    },
    nl: {
        lastname: "Achternaam is verplicht",
        firstname: "Voornaam is verplicht",
        emailInvalid: "Ongeldig e-mailadres",
        emailRequired: "E-mail is verplicht",
        phone: "Telefoon is verplicht",
        country: "Land is verplicht",
        postal: "Postcode is verplicht",
        gammes: "U moet ten minste één keuze selecteren",
        products: "U moet ten minste één keuze selecteren",
        gdpr: "Dit veld is verplicht"
    },
    de: {
        lastname: "Nachname ist erforderlich",
        firstname: "Vorname ist erforderlich",
        emailInvalid: "Ungültige E-Mail",
        emailRequired: "E-Mail ist erforderlich",
        phone: "Telefon ist erforderlich",
        country: "Land ist erforderlich",
        postal: "Postleitzahl ist erforderlich",
        gammes: "Sie müssen mindestens eine Auswahl treffen",
        products: "Sie müssen mindestens eine Auswahl treffen",
        gdpr: "Dieses Feld ist erforderlich"
    },
    es: {
        lastname: "El apellido es obligatorio",
        firstname: "El nombre es obligatorio",
        emailInvalid: "Correo electrónico no válido",
        emailRequired: "El correo electrónico es obligatorio",
        phone: "El teléfono es obligatorio",
        country: "El país es obligatorio",
        postal: "El código postal es obligatorio",
        gammes: "Debe seleccionar al menos una opción",
        products: "Debe seleccionar al menos una opción",
        gdpr: "Este campo es obligatorio"
    },
    it: {
        lastname: "Il cognome è obbligatorio",
        firstname: "Il nome è obbligatorio",
        emailInvalid: "Email non valida",
        emailRequired: "L'email è obbligatoria",
        phone: "Il telefono è obbligatorio",
        country: "Il paese è obbligatorio",
        postal: "Il codice postale è obbligatorio",
        gammes: "Devi selezionare almeno una scelta",
        products: "Devi selezionare almeno una scelta",
        gdpr: "Questo campo è obbligatorio"
    },
    pt: {
        lastname: "O sobrenome é obrigatório",
        firstname: "O nome é obrigatório",
        emailInvalid: "Email inválido",
        emailRequired: "O email é obrigatório",
        phone: "O telefone é obrigatório",
        country: "O país é obrigatório",
        postal: "O código postal é obrigatório",
        gammes: "Você deve selecionar pelo menos uma escolha",
        products: "Você deve selecionar pelo menos uma escolha",
        gdpr: "Este campo é obrigatório"
    }
  };

  function getErrorMessage(field, type, curLang) {
    return errorMessages[curLang][field + (type ? type : '')];
  }

  // Schemas for validation
  const stepValidators = [
    function validateStep1(data) {
      const errors = {};

      if (validator.isEmpty(data.lastname || '')) {
        errors.lastname = getErrorMessage('lastname', '', curLang);
      }

      if (validator.isEmpty(data.firstname || '')) {
        errors.firstname = getErrorMessage('firstname', '', curLang);
      }

      if (!validator.isEmail(data.email || '')) {
        errors.email = getErrorMessage('email', 'Invalid', curLang);
      } else if (validator.isEmpty(data.email || '')) {
        errors.email = getErrorMessage('email', 'Required', curLang);
      }

      if (validator.isEmpty(data.phone || '')) {
        errors.phone = getErrorMessage('phone', '', curLang);
      }
      // if (isPhoneWanted) {
      //     if (validator.isEmpty(data.phone || '')) {
      //       errors.phone = getErrorMessage('phone', '', curLang);
      //     }
      // }


      if (validator.isEmpty(data["00ND0000005obLk"] || '')) {
        errors["00ND0000005obLk"] = getErrorMessage('country', '', curLang);
      }

      let defaultCountry = data["00ND0000005obLk"];

      if (!data["00ND0000005obLk"]) {
        switch (curLocale) {
          case 'en':
          case 'fr':
          case 'nl':
          case 'de':
          case 'es':
          case 'it':
          case 'pt':
            defaultCountry = 'any';
            break;
          // case 'en-gb':
          //   defaultCountry = 'UK';
          //   break;
          case 'en-gb':
          case 'fr-fr':
          case 'fr-be':
          case 'fr-lu':
          case 'fr-ch':
          case 'nl-be':
          case 'de-de':
          case 'de-be':
          case 'de-ch':
          case 'it-it':
          case 'it-ch':
            defaultCountry = curLocale.split('-')[1].toUpperCase();
            break;
        
          default:
            break;
        }
      }
      
      
      let selectCountryValue = document.querySelector("#form-carousel > div.form-card.selected.step > div.form-inputs-outer > div.form-input-wrapper.input-country > select").value
      if (!validator.isPostalCode(data.postal || '', `${data["00ND0000005obLk"] || selectCountryValue || defaultCountry}`)) {  
        errors.postal = getErrorMessage('postal', '', curLang);
      }

      return errors;
    },

    function validateStep2(data) {
      const errors = {};
      if (!Array.isArray(data["gammes[]"]) || data["gammes[]"].length < 1) {
        errors["gammes[]"] = getErrorMessage('gammes', '', curLang);
      }
      return errors;
    },

    function validateStep3(data) {
      const errors = {};
      if (!Array.isArray(data["products[]"]) || data["products[]"].length < 1) {
        errors["products[]"] = getErrorMessage('products', '', curLang);
      }
      return errors;
    },

    function validateStep4(data) {
      const errors = {};
      if (!data.gdpr) {
        errors.gdpr = getErrorMessage('gdpr', '', curLang);
      }
      return errors;
    },
  ];

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    let selectedHeight = window.getComputedStyle(document.querySelector('.selected')).height;
    let topMargin = window.getComputedStyle(document.querySelector('#form-carousel')).marginTop;
    // loadingContainer.style.height = selectedHeight;
    // loadingContainer.style.top = topMargin;
    loadingContainer.classList.add("is-loading", "is-last");
    let formValues = {};

    for (var i = 0; i < e.target.elements.length; i++) {
      var element = e.target.elements[i];

      // Ignore les éléments qui ne sont pas pertinents
      if (element.type === "submit" || element.type === "button") continue;

      var name = element.name;
      var value = element.value;

      // Gérer les tableaux de valeurs
      if (name.endsWith("[]")) {
        var key = name.slice(0, -2); // Retire '[]' du nom

        if (!Array.isArray(formValues[key])) {
          formValues[key] = [];
        }
        if (
          element.checked ||
          (element.type !== "checkbox" && element.type !== "radio")
        ) {
          formValues[key].push(value);
        }
      } else {
        if (name == "00ND0000005obLk") {
          name = "country";
        }

        if (element.type !== "checkbox" && element.type !== "radio" && name) {
          formValues[name] = value;
        } else if (element.type === "checkbox") {
          formValues[name] = element.checked ? 1 : 0;
        }
      }
    }

    form.submit();

    // setTimeout(() => {
    //   loadingContainer.classList.remove("is-loading");
    //   carousel.classList.add("hide-carousel");
    //   if (window.innerWidth < 768) {
    //     const formImageMobile = document.getElementById("form-image-mobile");
    //     formImageMobile.style.height = '100%';
    //     h2.classList.remove('hide');
    //   }
    //   if (formImage) {
    //       formImage.classList.add("form-image-full");
    //   }
    //   document.querySelector('.form-outer').classList.add('form-sent')
    //   setTimeout(() => {
    //     figcaption.innerText = figcaption.dataset.thanks;
    //   }, 250);
    // }, 1000);
  });

  gammeInputContainer.addEventListener("change", setProductsInputs, false);


  for (var i = 0; i < gammeInputs.length; i++) {
    gammeInputs[i].addEventListener("click", function () {
      this.parentNode.classList.toggle("checked");
    });
  }

  for (var i = 0; i < productInputs.length; i++) {
    productInputs[i].addEventListener("click", function (e) {
      this.parentNode.classList.toggle("checked");
    });
  }

  function setProductsInputs(e) {
    let selectedGammeIds = [];
    gammeInputs.forEach(input => {
      if (input.checked) {
        selectedGammeIds.push(input.dataset.gammeId);
      }
    });

    // productInputList.forEach(list => list.style.display = 'none');
    const elementsArray = Array.from(productInputWrapper);
    elementsArray.forEach((wrapper) => (wrapper.style.display = "none"));
    let filteredElements = null;

    selectedGammeIds.forEach(gammeId => {
      switch (gammeId) {
        case '530':
        case '893':
        case '883':
          tag.value = 'bois';
          break;
        case '533':
        case '894':
        case '884':
          tag.value = 'bois';
          break;
        case '532':
        case '896':
        case '886':
          tag.value = 'pellets';
          break;
      }

            filteredElements = elementsArray.filter(element => element.dataset.gammeId == gammeId);
            filteredElements.unshift(elementsArray[0])
            filteredElements.forEach((element) => {
                element.style.display = "flex";
            });
    });
  }


  // Function to validate fields
  async function validateStep(step, validatorFn) {
    const inputs = step.querySelectorAll("input, select");
    const data = {};

    inputs.forEach((input) => {
        if (input.type === 'checkbox' && input.name === 'phone-wanted') {
            return;
        }

      let errorMessage = null;
      if ( input.type === "checkbox" && (input.name == "gammes[]" || input.name == "products[]") ) {
        if (!data[input.name]) {
          data[input.name] = [];
        }
        if (input.checked) {
          data[input.name].push(input.value);
        }
      } else if ( input.type === "checkbox" && (input.name == "gdpr" || input.name == "optin") ) {
        if (!data[input.name]) {
          data[input.name] = 0;
        }
        if (input.checked) {
          data[input.name] = 1;
        }
      } else {
        data[input.name] = input.value || '';
      }

      if ( input.name == "gammes[]" ||  input.name == "products[]" || input.name == "gdpr" || input.name == "optin" ) {
        input.parentElement.parentElement.classList.remove("is-invalid");        
        errorMessage = input.parentElement.parentElement.querySelector('.error-message');
      } else {
        input.parentElement.classList.remove("is-invalid");
        errorMessage = input.parentElement.querySelector('.error-message');
      }
      // Reset error state
      if (errorMessage) {
        errorMessage.innerText = "";
      }
    });

    const errors = validatorFn(data);

    if (Object.keys(errors).length === 0) {
      return true;
    } else {
      Object.keys(errors).forEach((key) => {
        const input = step.querySelector(`[name="${key}"]`);
        let errorMessage = null;
        if (!input) return false;
        if ( key == "gammes[]" || key == "products[]" || key == "gdpr" ) {
          input.parentElement.parentElement.classList.add("is-invalid");
          errorMessage = input.parentElement.parentElement.querySelector('.error-message');
        } else {
          input.parentElement.classList.add("is-invalid");
          errorMessage = input.parentElement.querySelector('.error-message');
        }

        if (errorMessage) {
          errorMessage.innerText = errors[key];
        }
      });
      return false;
    }
  }

  function validateField(input, validatorFn, showErrors = true) {
    const data = {};
    const errors = {};

    // Collecte des données du champ ou du groupe de champs
    if (input.type === 'checkbox' && input.name.endsWith('[]')) {
      const groupName = input.name.slice(0, -2); // Retirer '[]' du nom
      const checkboxes = document.querySelectorAll(`input[name="${input.name}"]`);
      data[input.name] = Array.from(checkboxes).map(cb => cb.checked ? cb.value : null).filter(value => value !== null);
    } else if (input.type === 'checkbox') {
      data[input.name] = input.checked ? 1 : 0;
    } else {
      data[input.name] = input.value || '';
    }

    // Validation du champ ou du groupe de champs
    const fieldErrors = validatorFn(data);
    if (showErrors) {
      // Réinitialisation de l'état de l'erreur
      input.parentElement.classList.remove("is-invalid");
      let errorMessage = input.parentElement.querySelector('.error-message');
      if (input.name == 'gammes[]' || input.name == 'products[]') {
          errorMessage = input.parentElement.parentElement.querySelector('.error-message');
        } 
      if (errorMessage) {
        errorMessage.innerText = "";
      }
      
      // Affichage de l'erreur si elle existe
      if (fieldErrors[input.name]) {
        input.parentElement.classList.add("is-invalid");
        
        if (errorMessage) {
          errorMessage.innerText = fieldErrors[input.name];
        }
      }
    }

    return fieldErrors[input.name] ? false : true;
  }

  // Function to enable/disable submit button
  function updateSubmitButton() {
    if (currentStep != document.querySelectorAll(".form-card").length) return false;
    let gdpr = document.querySelector('input[name="gdpr"]');
    if (!gdpr) {
        return false
    }

    submitButton.classList.remove('active');

    if (gdpr.checked) {
      submitButton.disabled = false;
      submitButton.classList.add('active');
    } else {
      submitButton.disabled = true;
    }
    // gdpr.checked ? submitButton.disabled = false : submitButton.disabled = true;
  }

  // Function to update arrow states based on validation
  function updateArrowState(step, validatorFn) {
    const inputs = step.querySelectorAll("input, select");
    let allValid = true;

    inputs.forEach((input) => {
      let showErrors = step.dataset.step == 1 ? false : true;
      const isValid = validateField(input, validatorFn, showErrors);
      if (!isValid) {
        allValid = false;
      }
    });

    step.dataset.stepValid = allValid;

    if (!step.dataset.stepValid) {
      return false;
    }
    
    const nextArrows = step.querySelectorAll(".arrow");
    if (!nextArrows) return false;

    if (allValid) {
      nextArrows.forEach(arrow => {
        arrow.classList.add("active");
      });
    } else {
      nextArrows.forEach(arrow => {
        arrow.classList.remove("active");
      });
    }
  }

  // Function to move to the selected step
  function moveToSelected(element) {
    var selected = null;
    if (element == "next") {
      selected = $(".selected").next();
    } else if (element == "prev") {
      selected = $(".selected").prev();
    } else {
      selected = element;
    }

    var next = $(selected).next();
    var prev = $(selected).prev();
    var prevSecond = $(prev).prev();
    var nextSecond = $(next).next();

    $(selected).removeClass().addClass("form-card selected step");
    $(selected).css('display', 'flex');

    const posElement = $(selected).index() + 1;
    carousel.dataset.current = posElement;
    currentStep = posElement;

    steps.dataset.step = currentStep

    for (let index = 0; index <  steps.children.length; index++) {
      const step = steps.children[index];
      if (step.tagName != 'div') {
        if (index <= (currentStep - 1)) {
          step.classList.remove('active')
          step.classList.add('active')
        } else {
          step.classList.remove('active')
        }
      }
    }


    /* image changer */
    /*
    if (posElement == 3 && !img.src.includes("form-default")) {
      img.classList.add("fade-out");
      setTimeout(() => {
        figcaption.classList.add("fade-out");
      }, 200);

      const newImageSrc = `img/form-default.jpg`;

      const preloadedImage = new Image();
      preloadedImage.onload = () => {
        img.src = newImageSrc;
        setTimeout(() => {
          figcaption.innerText = "";
        }, 250);
      };
      preloadedImage.src = newImageSrc;
    }
    */

    // $(selected).find("input").prop("disabled", false);
    $(prev).hide();
    $(prev).removeClass().addClass("form-card prev step");
    $(next).hide();
    $(next).removeClass().addClass("form-card next step");
    $(next).find("input[type=text]").val("");
    $(next).find("input[type=email]").val("");
    $(next).find("input[type=tel]").val("");
    $(next).find("input[type=number]").val("");
    $(next).find("input").prop("checked", false);

    if (currentStep == 2 && !settedGamme) {
        setPredefined('gamme')
    }
    if (currentStep == 2 && !settedProduct) {
        setPredefined('product')
    }

    $(nextSecond).removeClass().addClass("form-card nextSecond step");
    $(prevSecond).removeClass().addClass("form-card prevSecond step");

    // no limit
    $(nextSecond).nextAll().removeClass().addClass("form-card hideRight step");
    $(prevSecond).prevAll().removeClass().addClass("form-card hideLeft step");

    // if (window.innerWidth < 769) {
    //   console.log(window.innerWidth, document.forms[0]);
    //   document.forms[0].scrollIntoView()
    // }

    if (window.innerWidth < 768) {
      window.scrollTo({
        top: 170,
        behavior: "smooth",
      });
    }
  }

  function startLoading() {
    const figureWrapper = document.getElementById('figure-wrapper')
    const devis = document.getElementById('devis')
    let loadingWidth = window.innerWidth - figureWrapper.clientWidth

    loadingContainer.classList.add("is-loading");
    loadingContainer.style.width = `${loadingWidth}px`;
    if (window.innerWidth < 768) {
      loadingContainer.style.height = `${devis.clientHeight}px`;
      loadingContainer.style.width = `100%`;
      loadingContainer.style.transform = 'translateY(170px)'
    }
  }

  function stopLoading() {
    loadingContainer.classList.remove("is-loading");
  }


  // Add event listeners to arrows
  arrows.forEach((arrow) => {
    arrow.addEventListener("click", (event) => {
      event.preventDefault()
      if (arrow.classList.contains("active")) {
        startLoading()
        setTimeout(() => {
          stopLoading()
          moveToSelected("next");
        }, 1000);
      } else {
        if (event.target.tagName == "A" || event.target.tagName == "BUTTON") {
          validateStep(document.querySelector(`.form-card[data-step="${currentStep}"]`), stepValidators[currentStep - 1]);          
        }
      }
    });
  });

  // Add event listeners to form inputs to validate on change
  document.querySelectorAll(".form-card").forEach((card, index) => {
    const inputs = card.querySelectorAll("input, select");

    inputs.forEach((input) => {
        input.addEventListener("input", () => {
            if (input.type === 'checkbox' && input.name.endsWith('[]')) {
              const groupName = input.name;
              const checkboxes = document.querySelectorAll(`input[name="${groupName}"]`);
              checkboxes.forEach(cb => validateField(cb, stepValidators[index]));
            } else {
              validateField(input, stepValidators[index]);
            }
            updateArrowState(card, stepValidators[index]);
            updateSubmitButton();
            if (input.name == "postal") {
              // getDealers()
            }
        });
        input.addEventListener("blur", () => {
            if (input.type === 'checkbox' && input.name.endsWith('[]')) {
              // Valider tout le groupe de champs
              const groupName = input.name;
              const checkboxes = document.querySelectorAll(`input[name="${groupName}"]`);
              checkboxes.forEach(cb => validateField(cb, stepValidators[index]));
            } else {
              validateField(input, stepValidators[index]);
            }
            updateArrowState(card, stepValidators[index]);
            updateSubmitButton();
        });

        if (input.name == '00ND0000005obLk') {
          input.addEventListener("change", () => {
              // getDealers()
          });
        }
    });
  });

  $(".arrow-prev").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.target.previousElementSibling.classList.remove('active')
    moveToSelected("prev");
  })

  function getDealers() {
    let country = $('select[name="00ND0000005obLk"]').val();
      let postal = $('input[name="postal"]').val();
      // console.log(country, postal);
      if (country && postal) {
        startLoading()
        loadDatasOutsidePOS({Pays: country, codePostal: postal}).then(results => {
            // console.log("Données chargées avec succès :", results);
            stopLoading()
        })
        .catch(error => {
            // console.error("Erreur lors du chargement des données :", error);
        });
      }
  }

  function setPredefined(type) {
    if (!queryString) {
      return
    }

    switch (type) {
      case 'gamme':
        if (!settedGamme) {
          setGamme()
        }
        break;
      case 'product':
        if (!settedProduct) {
          setProduct()
        }
        break;
    }

    function setGamme() {
      urlParams = new URLSearchParams(queryString);
      urlGammes = urlParams.getAll('gamme');

      switch (curLang) {
        case 'fr':
          urlGammes.forEach(gamme => {
            if (gamme.includes('poeles-a-bois')) {
              urlGammes.push(530);
            } else if (gamme.includes('cheminees-decoratives')) {
              urlGammes.push(531);
            } else if (gamme.includes('a-pellets')) {
              urlGammes.push(532);
            } else if (gamme.includes('inserts-a-bois')) {
              urlGammes.push(533);
            }
          });
          break;
        case 'nl':
          urlGammes.forEach(gamme => {
            if (gamme.includes('houtkachels')) {
              urlGammes.push(883);
            } else if (gamme.includes('schouwen')) {
              urlGammes.push(885);
            } else if (gamme.includes('pelletkachels')) {
              urlGammes.push(886);
            } else if (gamme.includes('inbouwhaarden')) {
              urlGammes.push(884);
            }
          });
          break;
        default:
          urlGammes.forEach(gamme => {
            if (gamme.includes('wood-burning') || gamme.includes('kamino') || gamme.includes('stufa-a-legna')) {
              urlGammes.push(893);
            } else if (gamme.includes('ready') || gamme.includes('einbaufertige') || gamme.includes('stufa-pellet')) {
              urlGammes.push(895);
            } else if (gamme.includes('pellet-stove') || gamme.includes('pellettofen') || gamme.includes('inserti')) {
              urlGammes.push(896);
            } else if (gamme.includes('wood-inset') || gamme.includes('kamineinsatz') || gamme.includes('caminetti')) {
              urlGammes.push(894);
            }
          });
          break;
      }

      setTimeout(() => {
        urlGammes.forEach(urlGammeId => {
          let inputGamme = document.querySelector(`input[data-gamme-id='${urlGammeId}']`);
          if (inputGamme && !inputGamme.checked) {
            inputGamme.click();
            inputGamme.labels[0].classList.add("checked");
          }
        });
        settedGamme = true;
      }, 300);
    }

    function setProduct() {
      urlParams = new URLSearchParams(queryString);
      urlProducts = urlParams.getAll('p');
      setTimeout(() => {
        if (urlProducts) {
          urlProducts.forEach(urlProduct => {
            let inputProduct = document.querySelector(`input[data-value='${urlProduct}']`);
            if (inputProduct && !inputProduct.checked) {
              inputProduct.click();
              inputProduct.labels[0].classList.add('checked');
            }
          });
        }
        settedProduct = true;
      }, 300);
    }
  }
});
